import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _66f5f20a = function _66f5f20a() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _03f207ce = function _03f207ce() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _9c8cb088 = function _9c8cb088() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _6e1a9974 = function _6e1a9974() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _bb55c524 = function _bb55c524() {
  return interopDefault(import('../pages/_market/_language/cart.vue'
  /* webpackChunkName: "pages/_market/_language/cart" */
  ));
};

var _53a9b852 = function _53a9b852() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _37c23c8b = function _37c23c8b() {
  return interopDefault(import('../pages/_market/_language/login.vue'
  /* webpackChunkName: "pages/_market/_language/login" */
  ));
};

var _364f8cc6 = function _364f8cc6() {
  return interopDefault(import('../pages/_market/_language/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password" */
  ));
};

var _621cdba7 = function _621cdba7() {
  return interopDefault(import('../pages/_market/_language/reset-password.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password" */
  ));
};

var _0cdf41e6 = function _0cdf41e6() {
  return interopDefault(import('../pages/_market/_language/signup.vue'
  /* webpackChunkName: "pages/_market/_language/signup" */
  ));
};

var _7612c29a = function _7612c29a() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _92110062 = function _92110062() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _69f59f48 = function _69f59f48() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _1384f540 = function _1384f540() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _94d44ea8 = function _94d44ea8() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _52340a3d = function _52340a3d() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _8c0d146c = function _8c0d146c() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _084bb2f6 = function _084bb2f6() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _3d455cf1 = function _3d455cf1() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _62c4dfa6 = function _62c4dfa6() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _2b5d6630 = function _2b5d6630() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _36657d2a = function _36657d2a() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _5e61a28d = function _5e61a28d() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _44833ff3 = function _44833ff3() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
  ));
};

var _edca29a6 = function _edca29a6() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _6ba01e57 = function _6ba01e57() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _7651f637 = function _7651f637() {
  return interopDefault(import('../pages/_market/_language/t/shipping.vue'
  /* webpackChunkName: "pages/_market/_language/t/shipping" */
  ));
};

var _e6ad663e = function _e6ad663e() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _3367996c = function _3367996c() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _37556d8e = function _37556d8e() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _17f29933 = function _17f29933() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _11862d76 = function _11862d76() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _4b513246 = function _4b513246() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _68d58823 = function _68d58823() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _5e683127 = function _5e683127() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _e3225aaa = function _e3225aaa() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _3461c6ae = function _3461c6ae() {
  return interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
  ));
};

var _41eebcf4 = function _41eebcf4() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _bd38a5f2 = function _bd38a5f2() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _498f4518 = function _498f4518() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _a4369138 = function _a4369138() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _f9b4ac98 = function _f9b4ac98() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _770631c0 = function _770631c0() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _75d645c9 = function _75d645c9() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
  ));
};

var _2c596a96 = function _2c596a96() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
  ));
};

var _867f0b68 = function _867f0b68() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
  ));
};

var _0c1ecaba = function _0c1ecaba() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
  ));
};

var _77a0f6c3 = function _77a0f6c3() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
  ));
};

var _2eed154b = function _2eed154b() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _5c1ec734 = function _5c1ec734() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _18c44adc = function _18c44adc() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _7bdd8b01 = function _7bdd8b01() {
  return interopDefault(import('../pages/_market/_language/m/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/m/_alias" */
  ));
};

var _da1b09c4 = function _da1b09c4() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _75fea256 = function _75fea256() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _f2934af8 = function _f2934af8() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _66f5f20a,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _03f207ce,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _9c8cb088,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _6e1a9974,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _bb55c524,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _53a9b852,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _37c23c8b,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _364f8cc6,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _621cdba7,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _0cdf41e6,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _7612c29a,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _92110062,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _69f59f48,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _1384f540,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _94d44ea8,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _52340a3d,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _8c0d146c,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _084bb2f6,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _3d455cf1,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _62c4dfa6,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/login",
      component: _2b5d6630,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _36657d2a,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _5e61a28d,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-canceled",
      component: _44833ff3,
      name: "market-language-t-payment-paypal-canceled"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _edca29a6,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _6ba01e57,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/shipping",
      component: _7651f637,
      name: "market-language-t-shipping"
    }, {
      path: "/:market/:language/t/signup",
      component: _e6ad663e,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _3367996c,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _37556d8e,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _17f29933,
      children: [{
        path: "",
        component: _11862d76,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _4b513246,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _68d58823,
        name: "market-language-user-profile-alerts"
      }, {
        path: "password",
        component: _5e683127,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _e3225aaa,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/help/merchant/confirm",
      component: _3461c6ae,
      name: "market-language-help-merchant-confirm"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _41eebcf4,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _bd38a5f2,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _498f4518,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _a4369138,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _f9b4ac98,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _770631c0,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact",
      component: _75d645c9,
      name: "market-language-help-merchant-order-reference-contact"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/messages",
      component: _2c596a96,
      name: "market-language-help-merchant-order-reference-messages"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/notation",
      component: _867f0b68,
      name: "market-language-help-merchant-order-reference-notation"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/product/:code?",
      component: _0c1ecaba,
      name: "market-language-help-merchant-order-reference-contact-product-code"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/:code?",
      component: _77a0f6c3,
      name: "market-language-help-merchant-order-reference-contact-code"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _2eed154b,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _5c1ec734,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _18c44adc,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/m/:alias?",
      component: _7bdd8b01,
      name: "market-language-m-alias"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _da1b09c4,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _75fea256,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _f2934af8,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}